import { render } from "./B2bLoginPasswordFormCorreos.vue?vue&type=template&id=3446d6e3&scoped=true&lang=pug"
import script from "./B2bLoginPasswordFormCorreos.vue?vue&type=script&lang=js"
export * from "./B2bLoginPasswordFormCorreos.vue?vue&type=script&lang=js"

import "./B2bLoginPasswordFormCorreos.vue?vue&type=style&index=0&id=3446d6e3&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3446d6e3"]])

export default __exports__